/* RESPONSIBLE TEAM: team-self-serve */
import Transform from '@ember-data/serializer/transform';
import HashTransform from './hash';

type NullableRecord = Record<string, any> | null;

export default class NullableHashTransform extends Transform<NullableRecord, NullableRecord> {
  private hashTransform = HashTransform.create();

  serialize(deserialized: NullableRecord): NullableRecord {
    if (deserialized == null) {
      return deserialized;
    }
    return this.hashTransform.serialize(deserialized);
  }

  deserialize(serialized: NullableRecord): NullableRecord {
    if (serialized == null) {
      return serialized;
    }
    return this.hashTransform.deserialize(serialized);
  }
}
